import type { SendDigitsEventPublisher } from '@usecases/send-digits.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';

export class SendDigitsPublisher implements SendDigitsEventPublisher {
  async publish(digits: string): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'DIALER.SEND_DIGITS',
      payload: {
        digits,
      },
    };

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
